// src/pages/Education.js
import React, { useEffect, useState } from "react";
import {
  Container,
  Card,
  Spinner,
  Alert,
  Row,
  Col,
  Image,
} from "react-bootstrap";
import { getEducationList } from "../services/educationService";
import schoolLogo from "../assets/school.jpeg";
import collegeLogo from "../assets/college.jpg";

const Education = () => {
  const [educationList, setEducationList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    getEducationList()
      .then((res) => {
        const sorted = res.data.sort(
          (a, b) => new Date(b.startDate) - new Date(a.startDate)
        );
        setEducationList(sorted);
        setLoading(false);
      })
      .catch((err) => {
        setError("Failed to load education data.");
        setLoading(false);
        console.error(err);
      });
  }, []);

  if (loading) return <Spinner animation="border" variant="primary" />;
  if (error) return <Alert variant="danger">{error}</Alert>;

  const getLogo = (name) => {
    // Adjust based on actual institute name match
    if (name.toLowerCase().includes("school")) return schoolLogo;
    if (name.toLowerCase().includes("iit")) return collegeLogo;
    return schoolLogo;
  };

  return (
    <Container className="mt-4">
      <h2 className="mb-4 text-white text-center">🎓 My Education</h2>

      {educationList.map((edu) => (
        <Card
          key={edu.educationId}
          className="bg-gradient shadow-lg mb-4 text-white"
          style={{ background: "#212529", borderLeft: "5px solid #dc3545" }}
        >
          <Card.Body className="py-5">
            <Row className="align-items-center">
              <Col md={2} className="text-center mb-3 mb-md-0">
                <Image
                  src={getLogo(edu.intituteName)}
                  alt="Logo"
                  roundedCircle
                  fluid
                  style={{
                    width: "130px", // increased from 80px
                    height: "130px", // increased from 80px
                    objectFit: "cover",
                    border: "3px solid #dc3545", // optional border for highlight
                    padding: "4px", // space between border and image
                    backgroundColor: "#fff", // optional white background inside circle
                  }}
                />
              </Col>

              <Col md={10}>
                <h5 className="mb-1">
                  {edu.courseName} <span className="text-danger">|</span>{" "}
                  {edu.subjectName}
                </h5>

                <p className="mb-1 fw-bold text-info fs-5">
                  <i className="bi bi-building me-2"></i>
                  <a
                    href={edu.instituteLink || "#"}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-info text-decoration-none"
                  >
                    {edu.intituteName}
                  </a>
                </p>

                <p className="mb-1">
                  <strong>City:</strong> {edu.cityName || "N/A"}{" "}
                  <strong className="ms-3">Duration:</strong> {edu.startDate} -{" "}
                  {edu.endDate}
                </p>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      ))}
    </Container>
  );
};

export default Education;
